import * as geoUtils from "@/utils/geoDistance";
const baseURL = `${process.env.VUE_APP_SERVER_URL}/Ouvidoria`;

export async function ObterProtocolos({ vinculo, classificacao }) {
  return await window.$axios
    .get({
      url: `${baseURL}/ObterProtocolos`,
      query: {
        vinculo,
        idClassifica: classificacao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("ObterProtocolos", error.message);
      return error;
    });
}
export async function DetalheProtocolo({ vinculo, protocolo, classificacao }) {
  return await window.$axios
    .get({
      url: `${baseURL}/DetalheProtocolo`,
      query: {
        vinculo,
        protocolo,
        idClassifica: classificacao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("DetalheProtocolo", error.message);
      return error;
    });
}

export async function VerificarProtocoloReclamacao({ vinculo, protocolo }) {
  return await window.$axios
    .get({
      url: `${baseURL}/VerificarProtocoloReclamacao`,
      query: {
        vinculo,
        protocolo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("VerificarProtocoloReclamacao", error.message);
      return error;
    });
}

export async function SolicitarOuvidoria({ vinculo, protocolo, assunto, observacao, anexosN }) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("assunto", assunto);
  data.append("observacao", observacao);

  for (let index = 0; index < anexosN.length; index++) {
    const arquivo = anexosN[index];
    data.append(`anexo${index + 1}`, arquivo);
  }
  const coords: any = await geoUtils.GetLocation().catch(() => null);

  if (coords) {
    data.append("lat", coords?.latitude);
    data.append("lng", coords?.longitude);
  }
  return window.$axios
    .post({
      url: `${baseURL}/SolicitarOuvidoria`,
      query: {
        vinculo
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("SolicitarOuvidoria", error.message);
      return error;
    });
}

export function ObterDocumento({ vinculo, protocolo }) {
  const key = `${vinculo};${protocolo}`;
  const chave = `${window.$jse.encrypt(key)}`;

  const queryString = new URLSearchParams({
    vinculo,
    chave,
    tipo: ".pdf"
  }).toString();

  return `${baseURL}/ObterDocumento?${queryString}`;
}

export async function ObterImagem({ vinculo, documento, original }) {
  const key = `${vinculo};${documento};${original ? "T" : "F"}`;
  const chave = `${window.$jse.encrypt(key)}`;
  return await window.$axios
    .get({
      url: `${baseURL}/ObterImagem`,
      query: {
        vinculo,
        chave,
        original
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("ObterImagem", error.message);
      throw new Error(error.message);
    });
}

export async function RetornoPendencia({ vinculo, protocolo, observacao, arquivos, classificacao }) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("observacao", observacao);
  for (let index = 0; index < arquivos.length; index++) {
    data.append(`anexo${index + 1}`, arquivos[index]);
  }

  return window.$axios
    .post({
      url: `${baseURL}/RetornoPendencia`,
      query: {
        vinculo,
        idClassifica: classificacao
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      window.$log.error("RetornoPendencia", error.message);
      return error;
    });
}
